import React, { Component } from "react";
import { withStyles } from "@material-ui/core/styles";
import CustomText, {
    getFontSize,
    getFontWeight,
} from "../../components/CustomText";
import CustomBoard from "../../components/CustomBoard";
import "fontsource-muli";
import CustomButton from "../../components/CustomButton";
import { withRouter } from "react-router-dom";
import Image from "../../../assets";
import ContactModal from "./ContactPopUp";
class ExistingAcc extends Component {
    constructor(props) {
        super(props);
        this.state = {
            height: 0,
            key: '',
            title1: 'Something went wrong',
            title2: 'There was a problem with the information you provided. Please check your credentials and try again.',
            btn1Text: 'Try again',
            showBtn2: true,
            btn2Text: 'Back',
            isVisible: false,
        };
        this.updateWindowDimensions = this.updateWindowDimensions.bind(this);
    }
    componentDidMount() {
        window.scrollTo(0, 0);
        this.updateWindowDimensions();
        window.addEventListener("resize", this.updateWindowDimensions);
        const searchParams = new URLSearchParams(this.props.location.search);
        const key = searchParams.get('key') || '';
        this.setState({ key }, () => this.updateContentBasedOnKey());
    }
    componentWillUnmount() {
        window.removeEventListener("resize", this.updateWindowDimensions);
    }
    updateWindowDimensions() {
        this.setState({ height: window.innerHeight });
    }
    updateContentBasedOnKey = () => {
        const { key } = this.state;
        let title1 = 'Something went wrong';
        let title2 = 'There was a problem with the information you provided. Please check your credentials and try again.';
        let btn1Text = 'Try again';
        let showBtn2 = true;
        let btn2Text = 'Back';
        if (key === 'noPolicy') {
            title1 = "You'll need to be an Etiqa customer to register";
            title2 = "No matching policy was found with your ID. Please reach out to us if you need help.";
            btn1Text = 'Contact us';
            showBtn2 = true;
            btn2Text = 'Back';
        } else if (key === 'error') {
            title1 = 'We couldn’t complete your registration';
            title2 = 'Please ensure all details entered are correct';
            btn1Text = 'Try again';
            showBtn2 = true;
            btn2Text = 'Back';
        } else if (key === 'syserror') {
            title1 = 'Something went wrong';
            title2 = 'There was a problem with the information you provided. Please check your credentials and try again.';
            btn1Text = 'Try again';
            showBtn2 = true;
            btn2Text = 'Back';
        } else if (key === 'createFail') {
            title1 = 'Account creation unsuccessful';
            title2 = 'Some of the information provided appears to be duplicated. Our team is reviewing the details and will follow up with you as soon as possible.';
            btn1Text = 'Back';
            showBtn2 = false;
        }
        this.setState({ title1, title2, btn1Text, showBtn2, btn2Text });
    };
    onClickBtn1 = () => {
        const { history } = this.props;
        const { key, btn1Text } = this.state;
        history.push("/");
    };
    onClickBtn2 = () => {
        const { history } = this.props;
        history.push("/ForgotUserID");
    };
    onClickBtn3 = () => {
        const { history } = this.props;
        history.push("/ForgotPassword");
    };
    renderChildren = () => {
        const { classes } = this.props;
        const { title1, title2, btn1Text, showBtn2, btn2Text } = this.state;
        return (
            <div className={classes.contentContainer}>
                <img src={Image.wrongIcon} />
                <CustomText design={classes.headerTextStyle}>There’s an existing account</CustomText>
                <CustomText design={classes.headerTextStyleV2}>Please login</CustomText>
                <CustomButton
                    title={"login"}
                    design={classes.buttonStyle}
                    onClick={this.onClickBtn1}
                />

                <div style={{ cursor: 'pointer', marginTop: '1.4rem', color: '#0EA5E9', fontSize: '16px', fontWeight: '700' }} onClick={this.onClickBtn2}>{"Forget User ID"}</div>


                <div style={{ cursor: 'pointer', marginTop: '1.4rem', color: '#0EA5E9', fontSize: '16px', fontWeight: '700' }} onClick={this.onClickBtn3}>{"Forget Password"}</div>

            </div>
        );
    };
    render() {
        const { classes } = this.props;
        const { height } = this.state;
        return (
            <div className={classes.root}>
                <CustomBoard
                    children={this.renderChildren()}
                    height={height}
                />
                <ContactModal isVisible={this.state.isVisible} onClose={() => this.setState({ isVisible: false })} />
            </div>
        )
    }
}
const styles = (theme) => ({
    root: {
        flexGrow: 1,
        backgroundColor: "white",
    },
    headerTextStyle: {
        ...getFontWeight("bold"),
        fontSize: 20,
        textAlign: "center",
        color: "#171717",
        marginTop: 20
    },
    headerTextStyleV2: {
        fontSize: 16,
        textAlign: "center",
        color: "#686868",
        marginTop: 20,
        fontWeight:"normal !important"
    },
    buttonStyle: {
        // width: 160,
        marginTop: 25,
        height: 56,
        borderRadius: 4
    },
    imageStyle: {
        width: 100,
        height: 100
    },
    contentContainer: {
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center"
    }
});
export default withStyles(styles, { withTheme: true })(withRouter(ExistingAcc));